import { TFunction } from 'client/i18n/hooks/useT';
import { POLL_STATUS } from 'client/modules/AnchorAPI/v3/episodes/fetchInteractivityPoll';

export function getPollStatusLabel(status: POLL_STATUS, t: TFunction) {
  const pollStatusLabel = {
    LIVE: t(
      'EpisodeEditorPublish.InteractivePoll.PollStatusPublished',
      'Published',
      'Poll published status'
    ),
    DRAFT: t(
      'EpisodeEditorPublish.InteractivePoll.PollStatusDraft',
      'Draft',
      'Poll draft status'
    ),
    CLOSED: t(
      'EpisodeEditorPublish.InteractivePoll.PollStatusClosed',
      'Closed',
      'Poll closed status'
    ),
    SCHEDULED: t(
      'EpisodeEditorPublish.InteractivePoll.PollStatusScheduled',
      'Scheduled',
      'Poll scheduled status'
    ),
  };
  return pollStatusLabel[status];
}
